<template>
	<teleport to="body">
		<transition name="toggle-fade" appear>
			<div v-if="open" class="modal-bg"></div>
		</transition>

		<transition name="toggle-scale" appear>
			<div v-if="open" class="prompt-contain install-prompt" role="dialog" aria-modal="true" aria-labelledby="installPromptTitle">
				<div class="prompt-head">
					<div class="icon-contain">
						<img src="@/images/app-icon.png" />
					</div>
					<div class="content-contain">
						<strong id="installPromptTitle" class="action">{{ $t('prompts.installApp') }}</strong>
						<span class="desc">{{ $t('prompts.installRecommended') }}</span>
					</div>
				</div>
				<div class="prompt-body">
						<div class="android-warn" v-if="isAndroid">
						<div class="warn-head">
							<svg class="icon">
								<use href="#msg-warning"></use>
							</svg>
							{{ $t('prompts.googlePlayLoginRecommended') }}
						</div>
						<div class="warn-body">
							{{ $t('prompts.installAndroidInstructions') }}
							<a class="play-store-link" target="_blank" href="https://play.app.goo.gl/?link=https://play.google.com/store">
								{{ $t('prompts.googlePlayStore') }}
								<svg class="icon">
									<use href="#external"></use>
								</svg>
							</a>
							<span v-html="$t('prompts.beforeInstalling')"></span>
						</div>
					</div>
					<div class="answer-buttons">
						<button @click="showPwaInstall()" class="btn-confirm"><svg class="icon"><use href="#install"></use></svg> {{ $t('prompts.installAppButton') }}</button>
						<button @click="closeBanner()" class="btn-close">{{ $t('prompts.notRightNow') }}</button>
					</div>
				</div>
			</div>
		</transition>
	</teleport>
</template>

<script setup>
import { useStore } from '@/store';
import { computed } from 'vue';

const store = useStore();
const open = computed(() => store.showInstallBanner && !store.serviceWorkerUpdate);
const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;

function closeBanner() {
	store.setCustomPwaBanner(false);
	localStorage.setItem('pwaUserChoice', 'no');
}
function showPwaInstall() {
	store.setCustomPwaBanner(false);
	if (store.installPrompt?.prompt) {
		store.installPrompt.prompt();
	}

	store.installPrompt?.userChoice?.then?.((choiceResult) => {
		if (choiceResult.outcome === 'accepted') {
			store.showInstallButton = false;
		} else {
			localStorage.setItem('pwaUserChoice', 'no');
		}
		// Clear event after use; it can only be used once
		store.installPrompt = null;
	});
}
</script>
